import { useChartState } from './useChartState';

export const useIsBreakdownMode = () => {
  return useChartState().breakdownMode;
};
